import { Box } from "@mui/material";
import CustomDataGridV2 from "../../../../components/CustomDataGridV2";
import ToggleSwitch from "../../../../components/ToggleSwitch";
import DepartmentDrawer from "../../../../components/app/admin/provider-groups/DepartmentDrawer";
import { DepartmentType } from "../../../../dummy-data/department-data";
import { GridColDef, GridSortItem } from "@mui/x-data-grid";
import ActionMenu from "../../../../components/app/ActionMenu";
// import DeleteModal, {
//   useDeleteDisClosure,
// } from "../../../../components/app/DeleteModal";
import useDisclosure from "../../../../hooks/use-disclosure";
import { useState } from "react";
import { DepartmentInitialValuesType } from "../../../../constants/ProviderGroupFormInitialValues";
import { useStatusDepartMent } from "../../../../queries/use-status-department";
import { useOutletContext, useParams } from "react-router-dom";
import { useDepartmentList } from "../../../../queries/use-get-departments";
import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_UUID_NAME_LIST,
  DGT_Pagination,
  transformMultiSelectFrontEndVal,
} from "../../../../utils/utils";
import { useArchiveDepartMent } from "../../../../queries/use-archieve-department";
import DeleteModal, {
  useDeleteDisClosure,
} from "../../../../components/app/DeleteModal";
import Text from "../../../../components/Text";
import { getViewAs, getStoredRealm } from "@/utils/auth-storage";
// import { useArchiveDepartMent } from "../../../../queries/use-archieve-department";
const ProviderGroupDepartments = () => {
  const params = useParams();

  const { searchKey }: { searchKey: string; stateFilter: string } =
    useOutletContext();

  const realm = getStoredRealm();
  const viewAs = getViewAs();

  const [pagination, setPagination] = useState<DGT_Pagination>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const {
    data: ProviderGroupDepartmentList,
    refetch,
    isLoading: tableDataLoading,
    isFetching,
  } = useDepartmentList({
    gridSorting,
    pagination,
    searchKey,
    providerGroupId:
      params?.providerGroupId ?? (viewAs === "provider" ? realm : undefined),
  });

  const {
    opened: openedDeleteModal,
    open: openDeleteModal,
    close: closeDeleteModal,
    deleteId,
  } = useDeleteDisClosure(false);
  const { opened, open, close } = useDisclosure(false);
  const [departmentData, setDepartmentData] =
    useState<DepartmentInitialValuesType>();

  const { mutateAsync: statusChange } = useStatusDepartMent();
  const { mutateAsync: archiveDepartment } = useArchiveDepartMent();

  function toggleStatus<T>(value: boolean, id: T) {
    return statusChange({
      depId: id?.toString() ?? "",
      status: value,
      xTENANTID: params?.providerGroupId,
    }).then((res) => {
      refetch();
      return res;
    });
  }

  function archiveHandler<T>(value: boolean, id: T) {
    return archiveDepartment({
      depId: id?.toString() ?? "",
      status: value,
      xTENANTID: params?.providerGroupId,
    }).then((res) => {
      refetch();
      return res;
    });
  }

  const COLUMNS: GridColDef<DepartmentType>[] = [
    {
      field: "deptId",
      flex: 0.8,
      minWidth: 150,
      disableColumnMenu: true,
      headerName: "Department ID",
    },
    {
      field: "name",
      // headerAlign: "center",
      flex: 1,
      minWidth: 250,
      disableColumnMenu: true,
      headerName: "Department Name",
    },
    {
      field: "adminName",
      flex: 1,
      // minWidth: 250,
      disableColumnMenu: true,
      // headerAlign: "center",
      // align: "center",
      headerName: "Department Admin",
      renderCell: ({ value }) => {
        return <Text>{value ? value : "-"}</Text>;
      },
    },
    {
      field: "contact",
      flex: 1,
      // width: 250,
      disableColumnMenu: true,
      headerName: "Contact Number",
    },
    {
      flex: 1,
      field: "active",
      disableColumnMenu: true,
      headerName: "Status",
      renderCell: ({ row, value }) => (
        <ToggleSwitch
          id={row.uuid.toString()}
          checked={value}
          onConfirm={(v, id) => toggleStatus(v, id)}
        />
      ),
    },
    {
      field: "Action",
      hideSortIcons: true,
      renderCell: ({ row }: any) => {
        return (
          <ActionMenu
            options={[
              { value: "edit", label: "Edit" },
              {
                value: "delete",
                label: "Delete",
                isDisabled: (row as any)?.active,
              },
            ]}
            onActionClick={(v) => {
              if (v === "edit") {
                open();

                setDepartmentData({
                  ...row,
                  workLocations: transformMultiSelectFrontEndVal(
                    DEFAULT_UUID_NAME_LIST,
                    row.workLocations
                  ),
                });
              } else openDeleteModal(row.uuid);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box width={"100%"}>
      {opened && (
        <DepartmentDrawer
          open={opened}
          modalTitle={"Edit Department"}
          onClose={close}
          preFillValues={departmentData}
          xTENANTID={params.providerGroupId}
        />
      )}
      <DeleteModal
        w="380px"
        open={openedDeleteModal}
        onClose={closeDeleteModal}
        id={deleteId}
        onConfirmation={(id) => {
          return archiveHandler(true, id);
        }}
        content={"You want to delete this provider group Department"}
      />
      <Box height={"calc(100vh - 22rem)"}>
        <CustomDataGridV2
          loading={tableDataLoading || isFetching}
          searchString={searchKey}
          getRowId={(row) => row.uuid}
          rows={ProviderGroupDepartmentList?.data?.content ?? []}
          rowCount={ProviderGroupDepartmentList?.data?.page?.totalElements ?? 0}
          columns={COLUMNS}
          disableRowSelectionOnClick
          paginationModel={pagination}
          onPaginationModelChange={setPagination}
          onSortModelChange={setGridSorting}
        />
      </Box>
    </Box>
  );
};

export default ProviderGroupDepartments;
